import { useMemo } from 'react';
import { Button, Icon } from '@repo/ui';

import { useMatterAttemptsQuery } from '../../queries';
import { useMatterARContext } from '../common';
import ContactHistory from './ContactHistory';

export default function AttemptsSection() {
  const { currentMatterId, currentClientId } = useMatterARContext();
  const { data, isFetching, refetch } = useMatterAttemptsQuery(currentMatterId, currentClientId);

  const matterAttempts = useMemo(() => data?.data, [data]);
  return (
    <div className="flex flex-col gap-4 py-2">
      <div className="py-4">
        <h3 className="flex items-center">
          Previous Attempts{' '}
          <Button
            variant="outline"
            loading={isFetching}
            disabled={isFetching}
            onClick={() => refetch()}
            className="ml-4"
            size="sm"
            leftIcon={<Icon name="FiRefreshCw" />}
          >
            Reload
          </Button>
        </h3>
        <div className="flex flex-col">
          <ContactHistory matterAttempts={matterAttempts} isLoading={isFetching} />

          {!isFetching && !matterAttempts?.length && (
            <p className="min-h-40 flex justify-center items-center text-sm border border-xtnd-light dark:border-xtnd-dark rounded-md mt-4">
              No previous attempts have been recorded
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
